import { ILayoutBaseTestGen } from '../layoutBaseTest';
import { PdfGen } from '../../pdf/pdf';
import { render, BookOptions } from '../../pdf/book';
import { OptsBaseTest } from '../optsBaseTest';

export class TestBookImage implements ILayoutBaseTestGen {
  async generate(pdf: PdfGen, opts: OptsBaseTest): Promise<void> {
    await pdf.addStandardFonts();

    const markdown = `
# Ovoce — Image Module Test

## Inline images in text flow

Here is some text followed by a small image.

<img src="apple.png" width="60" height="60" alt="Apple"/>

Another paragraph after the apple image.

## Grid of fruit images

<img src="banana.png" width="100" height="80" alt="Banana"/>

<img src="cherry.png" width="100" height="80" alt="Cherry"/>

<img src="grapes.png" width="100" height="80" alt="Grapes"/>

<img src="kiwi.png" width="100" height="80" alt="Kiwi"/>

## Larger images

<img src="ananas.png" width="150" height="150" alt="Ananas"/>

<img src="melon.png" width="150" height="150" alt="Melon"/>

## Mixed content

This paragraph contains normal text before and after an image section.

<img src="strawberry.png" width="80" height="80" alt="Strawberry"/>

Text continues after the strawberry. The layout should flow naturally.

## More fruits

<img src="pear.png" width="100" height="100" alt="Pear"/>

<img src="avokado.png" width="100" height="100" alt="Avokado"/>

<img src="coconut.png" width="100" height="100" alt="Coconut"/>

<img src="raspberry.png" width="100" height="100" alt="Raspberry"/>

## Missing image fallback

<img src="nonexistent.png" width="80" height="80" alt="Missing fruit"/>
`.trim();

    const options: BookOptions = {
      fontSize: 11,
      lineHeight: 1.5,
      margin: 20,
      columns: 1,
    };

    await render(pdf, markdown, options);
  }
}
